import { gql } from "@apollo/client";

export const NEW_INCIDENT_MUTATION = gql`
  mutation newIncident($input: NewIncidentInput!) {
    newIncident(input: $input) {
      errors
      incidentId
      incident {
        id
        uuid
        ori {
          abbreviation
          agencyType
          id
          oriName
          requireDrugType
        }
        incidentNumber
        callTime
        classification {
          id
          name
        }
        incidentDetail {
          id
        }
        incidentReview {
          id
        }
        officerIncidentSpecifics {
          id
          secondaryAddress
          currentOfficerStatus
          statusId
          logCodeId
          logCode {
            id
            name
          }
          onSceneAt
          clearedAt
          officer {
            id
            deptAttribute {
              id
              badge
              assignment
              carNumber
              radioNumber
              lastContactedAt
              notes
              ori {
                id
                requireDrugType
                abbreviation
                oriName
              }
              secondaryAddress
              skillsList
              status
            }
          }
        }
        personIncidentSpecifics {
          id
          sealed
          bac
          juvenile
          yoe
          person {
            id
          }
        }
        address {
          name
        }
      }
    }
  }
`;

// Example input
// {
//   "input": {
// 	  "officerId": 3472,
//     "oriId": 1
//   }
// }
